<template lang="html">
    <div>
        <template v-if="undeletable.length">
            <p>Vous devez supprimer les entités liées à ces utilisateurs avant des pouvoir les supprimer :</p>
            <ul>
                <li v-for="user in undeletable">
                    <strong>{{ user.first_name }} {{ user.last_name }}</strong> :

                    <template v-for="(entity, index) in user.counts">
                        <template v-if="index > 0">, </template>
                        <span>{{ entity.count }} {{ entity.label }}</span>
                    </template>
                </li>
            </ul>
        </template>

        <template v-else>
            <p>Êtes-vous sûr de vouloir supprimer les utilisateurs suivants :</p>
            <ul>
                <li v-for="user in $store.state.datatable.users.selected">
                    {{ user.first_name }} {{ user.last_name }}
                </li>
            </ul>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                title:          'Suppression d\'utilisateurs',
                icon:           'delete',
                warning:        true,
                undeletable:    []
            }
        },

        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },

            onValidate() {
                this.$store.state.datatable.users.selected.forEach((item, index) => {
                    this.axios.delete(`/api/users/${item.id}`)
                        .then(response => {
                            this.$eventHub.$emit('close-modal')
                            this.$eventHub.$emit('reload-list')
                        })
                        .catch(err => console.log(err.response.data))
                })
            }
        },

        created() {
            let ids = ''
            this.$store.state.datatable.users.selected.forEach((item, index) => {
                ids += index > 0 ? ';' : ''
                ids += item.id
            })

            this.axios.get(`/api/users?filters=id|in|${ids}&embed=carts,orders,contacts`)
                .then(response => {
                    response.data.forEach((item, index) => {
                        let u = { id: item.id, first_name: item.first_name, last_name: item.last_name, counts: [] }

                        if(item.carts_count) {
                            u.counts.push({ label: 'paniers', 'count': item.carts_count })
                        }

                        if(item.orders_count) {
                            u.counts.push({ label: 'commandes', 'count': item.orders_count })
                        }

                        if(item.contacts_count) {
                            u.counts.push({ label: 'contacts', 'count': item.contacts_count })
                        }

                        if(u.counts.length) {
                            this.undeletable.push(u)
                            this.$eventHub.$emit('hide-modal-actions')
                        }
                    })
                })
                .catch(error => {
                    console.log(error.response.data)
                })
        }
    }
</script>

<style lang="stylus" scoped>
    div {
        padding: 1rem 4rem

        ul {
            margin-left: 3rem
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/admin/users/list/Delete.vue